/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mTask.vue?vue&type=template&id=0a5a4c7c&scoped=true"
import script from "./mTask.vue?vue&type=script&lang=js"
export * from "./mTask.vue?vue&type=script&lang=js"
import style0 from "./mTask.vue?vue&type=style&index=0&id=0a5a4c7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5a4c7c",
  null
  
)

export default component.exports